import React from 'react';

import { DeleteTwoTone } from '@ant-design/icons';
import { Button, Row, Space, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { OrderItemSchema } from '@app/models/orders';

import { useProjectOrderItems } from '../../../../providers';

import { AddProductModal } from '../AddProductModal';

import { columns } from './data/constants';

interface IProps {
  catalogUID?: string;
}

export const ItemsTable: React.FC<IProps> = (props) => {
  const [selectedRows, setSelectedRows] = React.useState<string[]>([]);
  const orderT = useTranslation(NSKeys.order);
  const commonT = useTranslation(NSKeys.common);
  const { onAddItem, items, onDeleteItems, onCountChange } = useProjectOrderItems();

  const handleDeleteClick = async () => {
    onDeleteItems(selectedRows);
    setSelectedRows([]);
  };

  const handleInputChange = async (value: number, cartItem: OrderItemSchema) => {
    onCountChange(value, cartItem.uid);
  };

  return (
    <React.Fragment>
      <Row justify="space-between" align="middle" style={{ height: '64px' }}>
        <Typography.Title level={3} style={{ marginBottom: 20 }}>
          {orderT.t('itemsTable.titleEmpty')}
        </Typography.Title>
        <Space>
          {props.catalogUID && (
            <AddProductModal
              onSelectItem={onAddItem}
              cartProducts={items?.map((el: any) => el.product.uid)}
              catalogUid={props.catalogUID}
            />
          )}
          {!!selectedRows.length && (
            <Button type="link" icon={<DeleteTwoTone />} onClick={handleDeleteClick}>
              {commonT.t('removeSelected')}
            </Button>
          )}
        </Space>
      </Row>
      <Table
        className="tableClassname"
        columns={columns(orderT.t, handleInputChange)}
        dataSource={items || undefined}
        pagination={false}
        rowKey="uid"
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: selectedRows,
          onChange: (selectedRowKeys) => {
            setSelectedRows(selectedRowKeys as any);
          },
        }}
      />
    </React.Fragment>
  );
};
